// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { get, post } from './api';
import { ENDPOINTS } from '../utils/constants';
import type { HitlApproval, HitlDecision, HitlDecisionRequest } from '../types';

export interface ListApprovalsFilters {
  siteId?: string;
  approvalType?: string;
  /** ISO timestamp; only approvals created on/after this time. */
  createdFrom?: string;
  /** ISO timestamp; only approvals created on/before this time. */
  createdTo?: string;
}

/**
 * List HITL approvals, optionally filtered by site, approval type, and
 * creation window. Filtering happens downstream in HITL itself.
 */
export const listApprovals = (filters: ListApprovalsFilters = {}): Promise<HitlApproval[]> => {
  const params = new URLSearchParams();
  if (filters.siteId) params.set('site_id', filters.siteId);
  if (filters.approvalType) params.set('approval_type', filters.approvalType);
  if (filters.createdFrom) params.set('created_from', filters.createdFrom);
  if (filters.createdTo) params.set('created_to', filters.createdTo);
  const qs = params.toString();
  return get<HitlApproval[]>(qs ? `${ENDPOINTS.HITL_APPROVALS}?${qs}` : ENDPOINTS.HITL_APPROVALS);
};

/** Submit an approve/reject decision for a pending review. */
export const submitReviewDecision = (
  reviewId: string,
  decision: HitlDecisionRequest
): Promise<HitlDecision> => post<HitlDecision>(ENDPOINTS.HITL_REVIEW_DECISIONS(reviewId), decision);
